import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // warm floor under the dicing circle so the stone never reads cold
  place(ctx, f.rug(art, 170, 170), 830, 1000);

  // HERO: dicing table at the centre (the settle/stools cluster around it)
  place(ctx, kit.diceTable(art, 40), 830, 1000);

  // off-duty stools at the four seat anchors (visible chair = the sit spot)
  place(ctx, kit.woodStool(art), 790, 1000); // barracks-stool-1
  place(ctx, kit.woodStool(art), 870, 1000); // barracks-stool-2
  place(ctx, kit.woodStool(art), 830, 960);  // barracks-stool-3
  place(ctx, kit.woodStool(art), 830, 1040); // barracks-stool-4

  // bunks flanking the north door (gap x770..890 kept clear between them)
  place(ctx, kit.bunkBed(art), 725, 908);
  place(ctx, kit.bunkBed(art), 935, 908);

  // south-wall fireplace (the fireside settle object sits in front of it)
  place(ctx, kit.fireplace(art, 80), 740, 1124);

  // east-wall guards' kit
  place(ctx, kit.weaponRack(art), 954, 950);

  // lived-in touches: the company hound dozing beside the fire + a firewood barrel (theme dressing,
  // not indoor greenery) in the SW corner.
  place(ctx, kit.houndAsleep(art), 812, 1096);
  place(ctx, kit.barrel(art), 690, 1092);

  // two braziers warming the dicing circle
  place(ctx, kit.brazier(art), 910, 960);
  place(ctx, kit.brazier(art), 700, 960);
};

export default decorate;
